"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * setCookie: Set a cookie
 * @param cName name of cookie that we want to modify
 * @param value value that we want to set to the cookie
 * @param exdays available cookie time from this moment
 * @param domain domains where the cookie aplies
 * @param needScape boolean if we want to scape special characters
 * @returns {void}
 */
const setCookie = (cName, value, exdays, domain = "", needScape = true) => {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    let cValue = "";
    const parsedValue = needScape ? escape(value) : value;
    if (!domain) {
        cValue =
            parsedValue +
                (exdays === null ? "" : `;expires=${exdate.toUTCString()};path=/`);
    }
    else {
        cValue =
            parsedValue +
                (exdays === null
                    ? ""
                    : `;expires=${exdate.toUTCString()};domain=${domain};path=/`);
    }
    document.cookie = `${cName}=${cValue}`;
};
exports.default = setCookie;
//# sourceMappingURL=index.js.map